import * as React from 'react';
const SvgReviewAppraisalTypeShort = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 25, height: 20, fill: "none" }, props),
    React.createElement("rect", { width: 18.59, height: 1.974, fill: "#fff", rx: 0.987 }),
    React.createElement("rect", { width: 18.59, height: 1.974, x: 6.41, y: 5.921, fill: "#fff", rx: 0.987 }),
    React.createElement("rect", { width: 18.59, height: 1.974, y: 11.84, fill: "#fff", rx: 0.987 }),
    React.createElement("rect", { width: 18.59, height: 1.974, x: 6.41, y: 17.763, fill: "#fff", rx: 0.987 })));
export default SvgReviewAppraisalTypeShort;
